import axios from "axios";
import qs from "qs";

export enum VoteType {
    Single = 0, // 单选
    Multiple = 1, // 多选
    Judge = 2 // 判断
}

export enum VoteState {
    Idle = 0, // 未开启
    InProgress = 1, // 进行中
    Done = 2 // 结束
}

export const VoteTypeMap = {
    [VoteType.Single]: "单选",
    [VoteType.Multiple]: "多选",
    [VoteType.Judge]: "判断"
};

export const VoteStateMap = {
    [VoteState.Idle]: "未开启",
    [VoteState.InProgress]: "进行中",
    [VoteState.Done]: "结束"
};

export enum StuVoteStatus {
    Idle = "1", // 待参与
    Done = "2", // 已参与
    Timeout = "3" // 已结束
}

export const StuVoteStatusMap = {
    [StuVoteStatus.Idle]: "待参与",
    [StuVoteStatus.Done]: "已参与",
    [StuVoteStatus.Timeout]: "已结束"
};

export interface StuVote {
    id: number;
    title: string;
    type: VoteType;
    validityTime: number | null;
    startTime: string;
    endTime: string;
    num: number;
    voteStatus: StuVoteStatus;
    status: VoteState;
}

/**
 * 学生投票列表
 * @param weekTimeId
 */
export function getStuVoteList(weekTimeId: number) {
    return axios
        .post<SuccessData<StuVote[]>>(
            "/student/vote/getStuVoteList",
            qs.stringify({ weekTimeId })
        )
        .then(res => res.data.data);
}

export interface AnswerDomain {
    id: number;
    content: string; // 内容
    changeStatus: string; // 学生选择状态0:未选1:选中
}

export interface VotePaperInfo {
    id: number;
    title: string;
    type: VoteType;
    status: VoteState;
    num: string;
    voteStatus: string; // 学生投票状态:0:未投1:已投
    voteTime: string;
    validityTime: number | null;
    startTime: string;
    endTime: string;
    voteAnswerDomainList: AnswerDomain[];
}

/**
 * 查看投票活动
 * @param votePaperId
 */
export function getVotePaperInfo(votePaperId: number) {
    return axios
        .post<SuccessData<VotePaperInfo>>(
            "/student/vote/getVotePaperInfo",
            qs.stringify({ votePaperId })
        )
        .then(res => res.data.data);
}

/**
 * 提交投票
 * @param votePaperId
 * @param voteAnswerId
 */
export function submitVotePaper(votePaperId: number, voteAnswerId: string) {
    return axios.post<SuccessData<VotePaperInfo>>(
        "/student/vote/submitVotePaper",
        qs.stringify({ votePaperId, voteAnswerId })
    );
}
